import {useAppSelector} from 'hooks';
import {ProductUnavailableReasonCodes} from 'types/recommedation-types/recommendations';
import {isDropShip} from 'utils/product';

export const useSortedItemsByDelivery = (includeUnavaialbleItems?: boolean) => {
  const {basket} = useAppSelector((state) => state.basket);
  const {currentStore} = useAppSelector((state) => state.app);

  const expressEligible = [];
  const standardEligible = [];
  const storePickupEligible = [];

  for (const item of basket?.basketItems || []) {
    const isActiveInRegularStore = item.productDetails.variants.find(
      (variant) => variant.storeCode === currentStore?.storeCodes?.[0]
    );

    if (item.productDetails?.isExpressEligible) {
      expressEligible.push(item);
    }
    if (isActiveInRegularStore || isDropShip(item.productDetails?.sellerDetails.marketplaceType)) {
      standardEligible.push(item);
    }
    if (
      isActiveInRegularStore &&
      !isDropShip(item.productDetails?.sellerDetails.marketplaceType) &&
      !item.productDetails.is1PX &&
      !item.productDetails.isBulky
    ) {
      storePickupEligible.push(item);
    }
  }

  if (includeUnavaialbleItems) {
    for (const item of basket?.unavailableItems || []) {
      if (item?.productDetails?.unavailableReason?.code === ProductUnavailableReasonCodes.NOT_ELIGIBLE_FOR_EXPRESS) {
        const isActiveInRegularStore = item.productDetails.variants.find(
          (variant) => variant.storeCode === currentStore?.storeCodes?.[0]
        );
        if (isActiveInRegularStore || isDropShip(item.productDetails?.sellerDetails.marketplaceType)) {
          standardEligible.push(item);
        }
        if (
          isActiveInRegularStore &&
          !isDropShip(item.productDetails?.sellerDetails.marketplaceType) &&
          !item.productDetails.is1PX &&
          !item.productDetails.isBulky
        ) {
          storePickupEligible.push(item);
        }
      }

      if (
        item?.productDetails?.unavailableReason?.code === ProductUnavailableReasonCodes.NOT_ELIGIBLE_FOR_STORE_PICKUP
      ) {
        const isActiveInRegularStore = item.productDetails.variants.find(
          (variant) => variant.storeCode === currentStore?.storeCodes?.[0]
        );
        if (item.productDetails?.isExpressEligible) {
          expressEligible.push(item);
        }
        if (isActiveInRegularStore || isDropShip(item.productDetails?.sellerDetails.marketplaceType)) {
          standardEligible.push(item);
        }
      }
    }
  }

  return {
    expressEligible,
    standardEligible,
    storePickupEligible
  };
};
